// resume.gazar.dev is the single canonical home of the CV. It renders at the
// host root so the URL you hand a recruiter is just the domain, and the old
// /resume-principal and /resume-senior paths redirect here rather than serving
// a second copy at a second URL.
//
// localhost is exempt: in dev there is no resume subdomain, so /resume-principal
// keeps rendering the page directly instead of bouncing you to production.
export const RESUME_URL = "https://resume.gazar.dev/";

export function isResumeHost(hostname: string) {
  return /^resume\./i.test(hostname);
}

export function isLocalHost(hostname: string) {
  return hostname === "localhost" || hostname === "127.0.0.1" || hostname.endsWith(".local");
}
